import React, { useState, useCallback } from 'react';
import t from '~t';

import { Error } from '~co/overlay/dialog';
import { Item, ItemTitle, Text } from '~ui';
import CollectionIcon from './icon';

export default function CollectionsItemRename({
  _id,
  title: initialTitle,
  level,
  cover,
  color,
  actions,
  onRenameCancel,
}) {
  const [title, setTitle] = useState(initialTitle);
  const [loading, setLoading] = useState(false);

  const onKeyUp = useCallback(
    (e) => {
      switch (e.keyCode) {
        case 27:
          return onRenameCancel();
      }
    },
    [onRenameCancel],
  );

  const save = useCallback(() => {
    //cancel
    if (!title.trim() || title == initialTitle) return onRenameCancel();

    //update collection
    setLoading(true);

    actions.oneUpdate(_id, { title }, onRenameCancel, (e) => {
      Error(e);
      onRenameCancel();
    });
  }, [title, initialTitle, _id, actions, onRenameCancel]);

  const onSubmit = useCallback(
    (e) => {
      e.preventDefault();
      e.stopPropagation();
      save();
    },
    [save],
  );

  return (
    <form onSubmit={onSubmit}>
      <Item
        color={color}
        className='ui-collection-item'
        style={{ '--level': level }}
      >
        <div className='ui-collection-expand' />

        <CollectionIcon
          cover={cover}
          _id={_id}
          active={true}
          loading={loading}
        />

        <ItemTitle>
          <Text
            type='text'
            variant='less'
            required
            autoFocus
            selectAll
            disabled={loading}
            value={title}
            placeholder={t.s('enterTitle')}
            onKeyUp={onKeyUp}
            onChange={(e) => setTitle(e.target.value)}
            onBlur={save}
          />
        </ItemTitle>
      </Item>
    </form>
  );
}
